import type { OrgRole } from '@lebinatikra/shared-types';
import { filterApiFetch } from './filter-api-client';

// Wire shape returned by POST /v1/organizations/:id/invitations.
// Filter API emits snake_case at the JSON boundary; do not confuse with the
// shared-types `UserInvitation` (camelCase Drizzle row).
export interface InvitationCreateResponse {
  id: string;
  organization_id: string;
  community_id: string;
  email: string | null;
  phone: string | null;
  role: OrgRole;
  status: 'pending';
  invite_code: string;
  accept_url: string;
  expires_at: string;
  delivery_status: string;
  delivery_provider_id: string | null;
  created_at: string;
}

export const invitationsApi = {
  create: (vars: { organizationId: string; email?: string; phone?: string; role: OrgRole }) =>
    filterApiFetch<InvitationCreateResponse>(
      `/v1/organizations/${vars.organizationId}/invitations`,
      {
        method: 'POST',
        body: JSON.stringify({ email: vars.email, phone: vars.phone, role: vars.role }),
      },
    ),
};
